"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HelpBlock = require("react-bootstrap/lib/HelpBlock");

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _IconError = require("../Icons/IconError");

var _IconError2 = _interopRequireDefault(_IconError);

var _IconWarning = require("../Icons/IconWarning");

var _IconWarning2 = _interopRequireDefault(_IconWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpBlockContainer = function HelpBlockContainer(_ref) {
  var message = _ref.message,
      status = _ref.status;

  return _react2.default.createElement(
    "div",
    { className: "help-block__wrapper" },
    status === "error" ? _react2.default.createElement(_IconError2.default, null) : status === "warning" ? _react2.default.createElement(_IconWarning2.default, null) : "",
    status && _react2.default.createElement(
      _HelpBlock2.default,
      null,
      message
    )
  );
};

HelpBlockContainer.propTypes = {
  message: _propTypes2.default.string,
  status: _propTypes2.default.string
};

exports.default = HelpBlockContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/HelpBlockContainer.js
// module id = 554
// module chunks = 0